import { render, staticRenderFns } from "./auto-message-condition-dialog.vue?vue&type=template&id=55955630&scoped=true&"
import script from "./auto-message-condition-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-message-condition-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55955630",
  null
  
)

export default component.exports